import { useEffect, useRef } from 'react';

import type { YMap, YMapMarker } from '@yandex/ymaps3-types';

import { MapPoint, YandexMapCoorinates } from './YandexMap.types';
import { addMarkers, setMapLocation, useInitYaMap } from './YandexMap.utils';

import styles from './YandexMap.module.scss';

type YandexMapProps = {
	mapId: string;
	className?: string;
	style?: {
		height?: number | string;
		width?: number | string;
	};
	center: YandexMapCoorinates;
	zoom?: number;
	markers?: MapPoint[];
	bounds?: YandexMapCoorinates[];
	boundsMargin?: number;
};

export const YandexMap = ({
	mapId,
	className,
	center,
	style,
	markers = [],
	zoom = 12,
	bounds,
	boundsMargin = 50,
}: YandexMapProps) => {
	const containerRef = useRef<HTMLDivElement | null>(null);
	const mapRef = useRef<YMap | null>(null);
	const markersRef = useRef<YMapMarker[]>([]);

	useInitYaMap({ center, containerRef, mapRef, markersRef, zoom, bounds, boundsMargin, markers });

	useEffect(() => {
		if (!mapRef.current) return;

		setMapLocation({ map: mapRef.current, center, zoom, bounds, boundsMargin });
	}, [bounds, boundsMargin, center, zoom]);

	useEffect(() => {
		if (!mapRef.current) return;

		const { YMapMarker } = ymaps3;

		addMarkers({ map: mapRef.current, markers, markersRef, YMapMarker });
	}, [markers]);

	return (
		<div
			id={mapId}
			className={`${styles.mapRoot} ${className ?? ''}`}
			style={{ width: style?.width ?? '100%', height: style?.height ?? 400 }}
			ref={containerRef}
		/>
	);
};
